import { ColumnType } from '../../enums/column-type';
import { FilterType } from '../../enums/filter-type';

/**
 * Informations sur un filtre.
 */
export class FilterInfos {
    /** Nom du champs sur lequel s'applique le filtre. */
    columnName: string;

    /** Valeur à filtrer. */
    value: string;

    /** type de filtre */
    type: ColumnType;

    filterType: FilterType;

    /** Indique s'il s'agit d'une selection multiple */
    selectionMultiple: boolean;
}
